import { anonymousClient, authenticatedClient } from './util'
import { HTTP_SUCCESS } from '../helpers/utils/http-status'
import { SubmitFormData } from '../repositories/UndertakingForm/types'

const fetchFormConfig = async () => {
    try {
        const response = await anonymousClient().get(`/api/undertaking-form-submission/config`)

        if (response.status !== HTTP_SUCCESS) {
            throw new Error(`Could not fetch undertaking form configuration. Status: ${response.status}`)
        }

        return response.data
    } catch (error) {
        console.error(`Error fetching form config:`, error)
        throw error
    }
}

const fetchSubmissionStatus = async () => {
    return authenticatedClient()
        .get(
            `/api/undertaking-form-submission/status`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not fetch undertaking form submission status`)
            }
            return res
        }).then(res => res.data)
}

const submitUndertakingForm = async (formData: SubmitFormData) => {
    return authenticatedClient()
        .post(
            `/api/undertaking-form-submission/submit`,
            formData,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not submit undertaking form`)
            }
            return res
        }).then(res => res.data)
}

export {
    fetchFormConfig,
    fetchSubmissionStatus,
    submitUndertakingForm,
}
